import { Field } from 'formik'
import React from 'react'

import { Fieldset, Input, Select, Textarea } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import type { Perk } from '../../../hooks/types'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'

export const CommonFields = () => {
  const { values } = useFormikContext<FormValues>()

  const selectOptions: { value: Perk['type']; label: string }[] = [
    { value: 'Custom', label: 'Custom perk' },
    { value: 'Discord', label: 'Discord roles' },
    { value: 'Discount', label: 'Members-only discounts' },
    { value: 'Product', label: 'Members-only products' },
    { value: 'Rss', label: 'Private RSS feed' },
  ]

  const renderDescriptionInput = () => {
    if (['Custom', 'Rss', 'Discord'].indexOf(values.type) >= 0) {
      return null
    }

    return (
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            component={Textarea}
            name={FormFields.description}
            label="Description (optional)"
            placeholder="Description (optional)"
          />
        </Fieldset.Item>
      </Fieldset.Row>
    )
  }

  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name={FormFields.type}
            component={Select}
            label="Perk type"
            options={selectOptions}
            disabled={values.mode === 'edit'}
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field component={Input} name={FormFields.title} label="Perk title" />
        </Fieldset.Item>
      </Fieldset.Row>
      {renderDescriptionInput()}
    </>
  )
}
